import { TripBookingGuideline } from '../../lib/types/models/trip-booking/trip-booking-guildeline'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripBookingGuideline(id: number) {
  return restApiClient
    .url(constructApiUrl(API.tripBookingGuidelines.get.url, { id }))
    .get<TripBookingGuideline>()
}
